import { Component, computed, input } from '@angular/core';

import { AdminsAvatarsComponent } from '@core/account-ui';
import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import { RatingScalePresentation } from '@core/candidate-evaluation-settings-types';
import type { AggregatedEvaluationsScore } from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';

import { EvaluationRatingScoreComponent } from '../../evaluation-rating-score/evaluation-rating-score.component';

const THUMBS_PRESENTATIONS = new Set([
  RatingScalePresentation.Thumbs4,
  RatingScalePresentation.Thumbs5,
]);

@Component({
  selector: 'rt-ratings-chart-tooltip',
  templateUrl: './ratings-chart-tooltip.component.html',
  styleUrl: './ratings-chart-tooltip.component.less',
  imports: [AdminsAvatarsComponent, EvaluationRatingScoreComponent, TranslatePipe],
})
export class RatingsChartTooltipComponent {
  protected readonly rows = computed(() => {
    const ratings = this.score().ratings;

    return (Array.isArray(ratings) ? ratings : [])
      .filter(rating => rating.answerCount > 0)
      .sort((a, b) => b.score - a.score);
  });

  protected readonly showIcon = computed(() =>
    THUMBS_PRESENTATIONS.has(this.evaluationScale().presentation),
  );

  public score = input.required<AggregatedEvaluationsScore>();
  public evaluationScale = input.required<RatingScale>();
}
